module.exports = {
	props: ['user', 'teams'],

	/**
	 * The component's data.
	 */
	data() {
		return {
			errorMessage: null,
			leavingTeam: null,
			deletingTeam: null,
			leaveTeamForm: new SparkForm({}),
			deleteTeamForm: new SparkForm({}),
			currentPage: 1,
			teamsPerPage: 20,
			searchQuery: '',
		};
	},
	/**
	 * Prepare the component.
	 */
	mounted() {
		$('[data-toggle="tooltip"]').tooltip();
	},
	computed: {
		/**
		 * Get the URL for leaving a team.
		 */
		urlForLeaving() {
			return `/settings/${Spark.teamsPrefix}/${this.leavingTeam.id}/members/${this.user.id}`;
		},
		totalPages() {
			return Math.ceil(this.filteredTeams.length / this.teamsPerPage);
		},
		/**
		 * Get the teams to display on the current page.
		 */
		paginatedTeams() {
			const start = (this.currentPage - 1) * this.teamsPerPage;
			const end = start + this.teamsPerPage;
			return this.filteredTeams.slice(start, end);
		},
		/**
		 * Get the array of pages to display in the pagination.
		 */
		paginationPages() {
			const totalPages = this.totalPages;
			const currentPage = this.currentPage;
			const pagesToShow = 10;
			let startPage = Math.max(currentPage - Math.floor(pagesToShow / 2), 1);
			let endPage = startPage + pagesToShow - 1;

			if (endPage > totalPages) {
				endPage = totalPages;
				startPage = Math.max(endPage - pagesToShow + 1, 1);
			}

			const pages = [];
			for (let i = startPage; i <= endPage; i++) {
				pages.push(i);
			}

			if (pages[0] > 1) {
				pages.unshift(1, '...');
			}
			if (pages[pages.length - 1] < totalPages) {
				pages.push('...', totalPages);
			}

			return pages;
		},

		/*
            Filtered teams based on search query and filters.
         */
		filteredTeams() {
			let teams = this.teams;

			// Apply search filter
			if (this.searchQuery) {
				teams = teams.filter((team) =>
					team.name.toLowerCase().includes(this.searchQuery.toLowerCase()),
				);
			}

			return teams;
		},
	},

	methods: {
		/**
		 * Change the current page.
		 */
		changePage(page) {
			if (page === '...') return;
			this.currentPage = page;
		},

		/**
		 * Approve leaving the given team.
		 */
		approveLeavingTeam(team) {
			this.leavingTeam = team;
			$('#modal-leave-team').modal('show');
		},

		leaveTeam() {
			Spark.delete(this.urlForLeaving, this.leaveTeamForm)
				.then(() => {
					Bus.$emit('updateUser');
					Bus.$emit('updateTeams');
				})
				.catch((error) => {
					this.errorMessage = error?.message;
				});

			$('#modal-leave-team').modal('hide');
		},
		/**
		 * Approve the deletion of the given team.
		 */
		approveTeamDelete(team) {
			this.deletingTeam = team;
			$('#modal-delete-team').modal('show');
		},
		/**
		 * Delete the given team.
		 */
		deleteTeam() {
			Spark.delete(
				`/settings/${Spark.teamsPrefix}/${this.deletingTeam.id}`,
				this.deleteTeamForm,
			).then(() => {
				Bus.$emit('updateUser');
				Bus.$emit('updateTeams');

				$('#modal-delete-team').modal('hide');
			});
		},
	},
};
